const validatePersonalNum = (value) => {
  const pattern = /^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/;
  return pattern.test(value) || "Введите номер в формате '0000000A000AA0'";
};

const validateSerialOfPassport = (value) => {
  const pattern = /^[A-Z]{2}$/;
  return pattern.test(value) || "Только 2 латинские буквы";
};

const validateDom = (value) => {
  const pattern = /^[1-9]\d*$/;
  return pattern.test(value) || "Только положительные числа больше нуля";
};

const validateBoatLength = (value) => {
  const numberValue = parseFloat(value);
  if (isNaN(numberValue) || numberValue <= 0 || numberValue > 20) {
    return "Должно быть больше 0 и меньше или равно 20";
  }
  return true;
};

const validatePassengersNum = (value) => {
  const pattern = /^(1[0-2]|[1-9])$/;
  return (
    pattern.test(value) ||
    "Число должно быть в диапазоне от 1 до 12 включительно"
  );
};

const validateUNP = (value) => {
  const pattern = /^\d{9}$/;

  return pattern.test(value) || "Значение должно состоять из 9 цифр";
};

const validatePastDate = (value) => {
  const enteredDate = new Date(value);
  const currentDate = new Date();

  if (enteredDate > currentDate) {
    return "Дата не может быть в будущем времени";
  }

  return true;
};

const validatePhone = (value) => {
  const pattern = /^[0-9()+\s]+$/;
  return pattern.test(value) || "Недопустимые символы: введите цифры, (), +";
};

export const registrationChangeType = [
  {
    value: 2,
    label: "Снятие с учета",
    key: "idTypeChangeStatement",
  },
  {
    value: 3,
    label: "Смена данных о судне",
    key: "idTypeChangeStatement",
  },
  {
    value: 1,
    label: "Смена данных о судовладельце",
    key: "idTypeChangeStatement",
  },
  {
    value: 4,
    label: "Аренда, лизинг",
    key: "idTypeChangeStatement",
  },
];

export const registrationFieldsHeader = [
  { id: "regNum", label: "Регистрационный номер маломерного судна" },
  { id: "personType", label: "Субъект хозяйствования" },
  { id: "tiketNum", label: "Номер судового билета" },
  { id: "ticketDate", label: "Дата выдачи судового билета" },
];

export const informationAboutInterestedPartyText = [
  { id: "persNum", label: "Идентификационный номер" },
  { id: "surname", label: "Фамилия" },
  { id: "name", label: "Имя" },
  { id: "midname", label: "Отчество" },
  { id: "docTypeName", label: "Документ" },
  { id: "serialOfPassport", label: "Серия" },
  { id: "numberOfPassport", label: "Номер" },
  { id: "docDateIssue", label: "Дата выдачи" },
  { id: "docDepartment", label: "Кем выдан" },
  { id: "stranId", label: "Страна" },
  { id: "oblIdName", label: "Область или г. Минск" },
  { id: "rayonIdName", label: "Район" },
  { id: "gorodIdName", label: "Населенный пункт" },
  { id: "ulica", label: "Улица" },
  { id: "dom", label: "Дом" },
  { id: "korpus", label: "Корпус" },
  { id: "kv", label: "Квартира" },
  { id: "phone", label: "Телефон" },
];

export const entityInformationAboutInterestedPartyText = [
  { id: "nameLe", label: "Наименование ЮЛ" },
  {
    id: "docDepartmentLe",
    label: "Наименование гос. организации, осуществляющей регистрацию",
  },
  { id: "egrNum", label: "Единый ЕГРЮЛиИП" },
  { id: "unp", label: "УНП" },
  { id: "stranId", label: "Страна" },
  { id: "oblIdName", label: "Область или г. Минск" },
  { id: "rayonIdName", label: "Район" },
  { id: "gorodIdName", label: "Населенный пункт" },
  { id: "ulica", label: "Улица" },
  { id: "dom", label: "Дом" },
  { id: "korpus", label: "Корпус" },
  { id: "kv", label: "Квартира (офис)" },
  { id: "phone", label: "Телефон" },
];

export const entityInformationAboutInterestedPartyInput = [
  {
    id: "unp",
    label: "УНП",
    type: "input",
    placeholder: "Введите",
    isRequired: true,
    validation: () => ({
      validate: (value) => {
        return validateUNP(value);
      },
    }),
    button: {
      id: "customButton3",
      label: "Найти",
      searchIcon: true,
    },
    upperCase: true,
  },
  // {
  //   id: "customButton3",
  //   label: "Найти",
  //   type: "button",
  // },
  {
    id: "nameLe",
    label: "Наименование ЮЛ",
    type: "input",
    placeholder: "Введите",
    isRequired: true,
    upperCase: true,
  },
  {
    id: "docDepartmentLe",
    label: "Наименование гос. организации, осуществляющей регистрацию",
    type: "input",
    placeholder: "Введите",
    isRequired: true,
    upperCase: true,
  },
  {
    id: "egrNum",
    label: "Единый ЕГРЮЛиИП",
    type: "input",
    placeholder: "Введите",
    isRequired: true,
    upperCase: true,
  },
  {
    id: "stranId",
    label: "Страна",
    type: "input",
    placeholder: "Введите",
    disabled: true,
    upperCase: true,
  },
  {
    id: "rayonId",
    label: "Район",
    type: "select",
    options: [],
    disabled: false,
    placeholder: "Выберите",
  },
  {
    id: "ulica",
    label: "Улица",
    type: "input",
    placeholder: "Введите",
    upperCase: true,
  },
  {
    id: "kv",
    label: "Квартира (офис)",
    type: "input",
    placeholder: "Введите",
    upperCase: true,
  },
  {
    id: "oblId",
    label: "Область или г.Минск",
    type: "select",
    options: [],
    placeholder: "Выберите",
    isRequired: true,
  },
  {
    id: "gorodId",
    label: "Населённый пункт",
    type: "select",
    options: [],
    placeholder: "Выберите",
    disabled: false,
  },
  {
    id: "dom",
    label: "Дом",
    type: "input",
    placeholder: "Введите",
    isRequired: true,
    validation: () => ({
      validate: (value) => {
        return validateDom(value);
      },
    }),
    upperCase: true,
  },
  { id: "korpus", label: "Корпус", type: "input", placeholder: "Введите" },
  {
    id: "phone",
    label: "Телефон",
    type: "input",
    placeholder: "+375 (29) ___-__-__",
    validation: () => ({
      validate: (value) => {
        if (!value) return true;

        return validatePhone(value);
      },
    }),
  },
];

export const informationAboutInterestedPartyInput = [
  {
    id: "persNum",
    label: "Идентификационный номер",
    type: "input",
    placeholder: "Введите",
    isRequired: true,
    validation: () => ({
      validate: (value) => {
        return validatePersonalNum(value);
      },
    }),
    button: {
      id: "customButton",
      label: "Найти",
      searchIcon: true,
    },
    upperCase: true,
  },
  {
    id: "surname",
    label: "Фамилия",
    type: "input",
    placeholder: "Введите",
    isRequired: true,
    upperCase: true,
  },
  {
    id: "name",
    label: "Имя",
    type: "input",
    placeholder: "Введите",
    isRequired: true,
    upperCase: true,
  },
  {
    id: "midname",
    label: "Отчество",
    type: "input",
    placeholder: "Введите",
    upperCase: true,
  },
  {
    id: "docType",
    label: "Документ",
    type: "select",
    options: [],
    placeholder: "Выберите документ",
    isRequired: true,
  },
  {
    id: "serialOfPassport",
    label: "Серия",
    type: "input",
    placeholder: "Введите",
    isRequired: true,
    validation: () => ({
      validate: (value) => {
        return validateSerialOfPassport(value);
      },
    }),
    upperCase: true,
  },
  {
    id: "numberOfPassport",
    label: "Номер",
    type: "input",
    placeholder: "Введите",
    isRequired: true,
    upperCase: true,
  },
  {
    id: "docDateIssue",
    label: "Дата выдачи",
    type: "date",
    isRequired: true,
    validation: () => ({
      validate: (value) => {
        return validatePastDate(value);
      },
    }),
  },
  {
    id: "docDepartment",
    label: "Кем выдан",
    type: "input",
    placeholder: "Введите",
    isRequired: true,
    upperCase: true,
  },
  {
    id: "stranId",
    label: "Страна",
    type: "input",
    placeholder: "Введите",
    disabled: true,
    upperCase: true,
  },
  {
    id: "rayonId",
    label: "Район",
    type: "select",
    options: [],
    disabled: false,
    placeholder: "Выберите",
  },
  {
    id: "ulica",
    label: "Улица",
    type: "input",
    placeholder: "Введите",
    upperCase: true,
  },
  {
    id: "kv",
    label: "Квартира",
    type: "input",
    placeholder: "Введите",
    upperCase: true,
  },
  {
    id: "oblId",
    label: "Область или г.Минск",
    type: "select",
    options: [],
    placeholder: "Выберите",
    isRequired: true,
  },
  {
    id: "gorodId",
    label: "Населённый пункт",
    type: "select",
    options: [],
    placeholder: "Выберите",
    disabled: false,
  },
  {
    id: "dom",
    label: "Дом",
    type: "input",
    placeholder: "Введите",
    isRequired: true,
    validation: () => ({
      validate: (value) => {
        return validateDom(value);
      },
    }),
    upperCase: true,
  },
  {
    id: "korpus",
    label: "Корпус",
    type: "input",
    placeholder: "Введите",
    upperCase: true,
  },
  {
    id: "phone",
    label: "Телефон",
    type: "input",
    placeholder: "+375 (29) ___-__-__",
    validation: () => ({
      validate: (value) => {
        if (!value) return true;

        return validatePhone(value);
      },
    }),
  },
];

export const informationAboutAgentInterestedPartyInput = [
  {
    id: "agentPersNum",
    label: "Идентификационный номер",
    type: "input",
    placeholder: "Введите",
    validation: () => ({
      validate: (value) => {
        if (!value) return true;

        return validatePersonalNum(value);
      },
    }),
    button: {
      id: "customButton2",
      label: "Найти",
      searchIcon: true,
    },
    upperCase: true,
  },
  {
    id: "agentSurname",
    label: "Фамилия",
    type: "input",
    placeholder: "Введите",
    upperCase: true,
  },
  {
    id: "agentName",
    label: "Имя",
    type: "input",
    placeholder: "Введите",
    upperCase: true,
  },
  {
    id: "agentMidname",
    label: "Отчество",
    type: "input",
    placeholder: "Введите",
    upperCase: true,
  },
  {
    id: "agentDocType",
    label: "Документ",
    type: "select",
    options: [],
    placeholder: "Выберите документ",
    upperCase: true,
  },
  {
    id: "agentSerialOfPassport",
    label: "Серия",
    type: "input",
    placeholder: "Введите",
    validation: () => ({
      validate: (value) => {
        if (!value) return true;

        return validateSerialOfPassport(value);
      },
    }),
    upperCase: true,
  },
  {
    id: "agentNumberOfPassport",
    label: "Номер",
    type: "input",
    placeholder: "Введите",
    upperCase: true,
  },
  {
    id: "agentDocDate",
    label: "Дата выдачи",
    type: "date",
    validation: () => ({
      validate: (value) => {
        if (!value) return true;

        return validatePastDate(value);
      },
    }),
  },
  {
    id: "agentDocDepartment",
    label: "Кем выдан",
    type: "input",
    placeholder: "Введите",
    upperCase: true,
  },
  {
    id: "agentCountry",
    label: "Страна",
    type: "input",
    placeholder: "Введите",
    disabled: true,
    upperCase: true,
  },
  {
    id: "agentRayonId",
    label: "Район",
    type: "select",
    options: [],
    disabled: true,
    placeholder: "Выберите",
    upperCase: true,
  },
  {
    id: "agentUlica",
    label: "Улица",
    type: "input",
    placeholder: "Введите",
    upperCase: true,
  },
  {
    id: "agentKv",
    label: "Квартира",
    type: "input",
    placeholder: "Введите",
    upperCase: true,
  },
  {
    id: "agentOblId",
    label: "Область или г.Минск",
    type: "select",
    options: [],
    placeholder: "Выберите",
    upperCase: true,
  },
  {
    id: "agentGorodId",
    label: "Населённый пункт",
    type: "select",
    options: [],
    placeholder: "Выберите",
    disabled: true,
    upperCase: true,
  },
  {
    id: "agentDom",
    label: "Дом",
    type: "input",
    placeholder: "Введите",
    validation: () => ({
      validate: (value) => {
        if (!value) return true;

        return validateDom(value);
      },
    }),
    upperCase: true,
  },
  {
    id: "agentKorpus",
    label: "Корпус",
    type: "input",
    placeholder: "Введите",
    upperCase: true,
  },
  {
    id: "agentPhone",
    label: "Телефон",
    type: "input",
    placeholder: "+375 (29) ___-__-__",
    validation: () => ({
      validate: (value) => {
        if (!value) return true;

        return validatePhone(value);
      },
    }),
  },
  {
    id: "agentDoverennost",
    label: "Сведения о доверенности",
    type: "input",
    placeholder: "Введите",
    upperCase: true,
  },
];

export const informationAboutSmallVesselText = [
  { id: "boatVin", label: "Заводской (идентификационный) номер" },
  { id: "boatYear", label: "Год постройки" },
  { id: "boatName", label: "Название (при наличии)" },
  { id: "boatTypeName", label: "Тип" },
  { id: "boatVidName", label: "Вид" },
  { id: "bodyMaterialName", label: "Материал корпуса" },
  { id: "parkingPlace", label: "Место стоянки" },
  { id: "engineNum", label: "Количество двигателей" },
  { id: "saCategoryName", label: "Категория сложности района плавания" },
  { id: "boatPayload", label: "Грузоподъемность (кг)" },
  { id: "engpwrmax", label: "Предельная мощность двигателей, л.с." },
  { id: "boatLength", label: "Длина (м)" },
  { id: "boatWidth", label: "Ширина (м)" },
  { id: "boatHeight", label: "Высота (м)" },
  { id: "passengersNum", label: "Пассажировместимость (чел.)" },
];

export const informationAboutSmallVessel = [
  {
    id: "boatVin",
    label: "Заводской (идентификационный) номер",
    type: "input",
    placeholder: "Введите",
    disabled: true,
    isRequired: true,
  },
  {
    id: "boatYear",
    label: "Год постройки",
    type: "input",
    placeholder: "Введите",
    disabled: true,
    isRequired: true,
  },
  {
    id: "boatName",
    label: "Название (при наличии)",
    type: "input",
    placeholder: "Введите",
  },
  {
    id: "boatType",
    label: "Тип",
    type: "select",
    options: [],
    placeholder: "Выберите",
    isRequired: true,
  },
  {
    id: "boatVid",
    label: "Вид",
    type: "select",
    options: [],
    placeholder: "Выберите",
    isRequired: true,
  },
  {
    id: "bodyMaterial",
    label: "Материал корпуса",
    type: "select",
    options: [],
    placeholder: "Выберите",
    disabled: true,
    isRequired: true,
  },
  {
    id: "parkingPlace",
    label: "Место стоянки",
    type: "input",
    placeholder: "Введите",
    isRequired: true,
  },
  {
    id: "engineNum",
    label: "Количество двигателей",
    type: "input",
    placeholder: "Введите",
  },
  {
    id: "saCategory",
    label: "Категория сложности района плавания",
    type: "select",
    options: [],
    placeholder: "Выберите",
    isRequired: true,
  },
  {
    id: "boatPayload",
    label: "Грузоподъемность (кг)",
    type: "input",
    placeholder: "Введите",
    isRequired: true,
  },
  {
    id: "engpwrmax",
    label: "Предельная мощность двигателей, л.с.",
    type: "input",
    placeholder: "Введите",
  },
  {
    id: "boatLength",
    label: "Длина (м)",
    type: "input",
    placeholder: "Введите",
    isRequired: true,
    validation: () => ({
      validate: (value) => {
        return validateBoatLength(value);
      },
    }),
  },
  {
    id: "boatWidth",
    label: "Ширина (м)",
    type: "input",
    placeholder: "Введите",
    isRequired: true,
  },
  {
    id: "boatHeight",
    label: "Высота (м)",
    type: "input",
    placeholder: "Введите",
    isRequired: true,
  },
  {
    id: "passengersNum",
    label: "Пассажировместимость (чел.)",
    type: "input",
    placeholder: "Введите",
    isRequired: true,
    validation: () => ({
      validate: (value) => {
        return validatePassengersNum(value);
      },
    }),
  },
];

export const STATIONARY_ENGINES_SMALL_VESSELS = [
  {
    Header: "Заводской (идентификационный) номер",
    accessor: "engnum",
  },
  {
    Header: "Мощность, л.с.",
    accessor: "engpwr",
  },
];

export const SMALL_BOAT_OUTBOARD_ENGINES = [
  {
    Header: "Название",
    accessor: "engname",
  },
  {
    Header: "Заводской (идентификационный) номер",
    accessor: "engvin",
  },
  {
    Header: "Тип двигателя",
    accessor: "engtypeName",
  },
  {
    Header: "Мощность, л.с.",
    accessor: "engpwr",
  },
  {
    Header: "Год выпуска",
    accessor: "engProdYear",
  },
  {
    Header: "Дата постановки на учет",
    accessor: "dateReg",
  },
  {
    Header: "Дата снятия с учета",
    accessor: "dateRegEnd",
  },
];

export const ARRESTS_IMPOSED = [
  {
    Header: "Дата",
    accessor: "dateText",
  },
  {
    Header: "Признак ареста",
    accessor: "isActiveText",
  },
  {
    Header: "Орган",
    accessor: "orgText",
  },
  {
    Header: "Должностное лицо, принявшее решение",
    accessor: "officerText",
  },
  {
    Header: "Наименование, номер и дата документа",
    accessor: "nameNumDateOfDocText",
  },
  {
    Header: "Примечание",
    accessor: "noteText",
  },
];

export const SPECIAL_NOTES = [
  {
    Header: "Ограничение на рег. действия",
    accessor: "msmLock",
  },
  {
    Header: "Дата",
    accessor: "msmDate",
  },
  {
    Header: "Отметка",
    accessor: "msmNote",
  },
];

export const getInformationAboutInterestedPartyInput = () => {
  return informationAboutInterestedPartyInput;
};

export const getEntityInformationAboutInterestedPartyInput = () => {
  return entityInformationAboutInterestedPartyInput;
};

export const getInformationAboutAgentInterestedPartyInput = () => {
  return informationAboutAgentInterestedPartyInput;
};

export const getInformationAboutSmallVessel = () => {
  return informationAboutSmallVessel;
};

export const setSelectOptionsForFields = (settingsArray, id, values) => {
  return settingsArray.map((item) =>
    item.id === id && item.type === "select"
      ? { ...item, options: values }
      : item,
  );
};

export const setDisabledForFields = (settingsArray, ids, disabled) => {
  const idArray = Array.isArray(ids) ? ids : [ids];

  return settingsArray.map((item) =>
    idArray.includes(item.id) ? { ...item, disabled } : item,
  );
};

export const setRequirementForFields = (settingsArray, ids, isRequired) => {
  return settingsArray.map((field) =>
    ids.includes(field.id) ? { ...field, isRequired } : field,
  );
};
